<template>
  <div class="app-container">
    <el-table :data="tableData" style="width: 100%" :header-cell-style="{
      backgroundColor: '#0E59CB',
      color: '#fff',
    }" :default-sort="{ prop: 'date', order: 'descending' }" ref="singleTable" :highlight-selection-row="false"
      :row-class-name="tableRowClassName">
      <el-table-column prop="hswyxj" show-overflow-tooltip label="“红色物业”星级" align="center">
        <template slot-scope="scope">

          <b style="font-size: 18px;">
            <span>★</span>
            <span>★</span>
            <span>★</span>
          </b>


          <!-- <b style="font-size: 18px;">
            <span v-for="(item, index) in parseInt(scope.row.hswyxj || 0)" :key="index">★</span>
            <span v-if="!scope.row.hswyxj">--</span>
          </b> -->
          
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="bjsfxqpm"
        align="center"
        show-overflow-tooltip
        label="百佳示范小区"
      >
        <template slot-scope="scope">
          <div style="color: #fff">已评选</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="mhjypx"
        align="center"
        show-overflow-tooltip
        label="美好家园评选"
      >
        <template slot-scope="scope">
          <div style="color: #fff">已评选</div>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import api from "@/api/starand.js";

export default {
  data() {
    return {
      tableData: [
        {
          date: "★ ★ ★ ★ ★",
          name: "13名",
          address: "5名",
        },
      ],
      query: {
        total: 0,
        pageNum: 1,
        pageSize: 6,
      },
    };
  },
  mounted() {
    this.initPypx();
  },
  methods: {
    //评优评先
    initPypx() {
      // api.bzhjspypx().then((res) => {
      //   console.log(res, "----");
      //   if (res.data.code == 200 && res.data.data) {
      //     this.tableData = res.data.data.list || [];
      //   } else {
      //     this.tableData = [];
      //   }
      // });

      api.wygk().then(res => {
        this.tableData = [res.data.data]
      })



    },
    //奇偶行背景色不同
    tableRowClassName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.el-table .warning-row {
  background-color: #0f53a5 !important;
  color: #fff !important;
}

::v-deep.el-table .success-row {
  background-color: #193a5c !important;
  color: #fff !important;
}

::v-deep.el-table tbody tr:hover>td {
  background-color: unset !important;
}

::v-deep.el-table__body {
  border-color: #0f53a5 !important;
}

.el-table {
  border-bottom: 1px solid #1763e8;
  border-right: 1px solid #1763e8;
  margin: 0 auto;
}

::v-deep.el-table th {
  border: 1px solid #1763e8 !important;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep.el-table td {
  border: 1px solid #1763e8;
  height: 20px;
  border-right: none !important;
  border-bottom: none !important;
}

::v-deep .el-table__empty-block {
  background-color: #0e59cb;
}

::v-deep .el-table__empty-text {
  color: #fff;
}
</style>
